import { GDSHeadingLevel } from '@leagueplatform/genesis-core';

/**
 * Gets the next heading level for sub-headings.
 *
 * @param headingLevel - The current heading level (1-6, 'display', or undefined)
 * @returns The next heading level, and 'display' is returned unchanged
 */

export const getSubHeadingLevel = (
  parentHeadingLevel?: GDSHeadingLevel,
  fallbackLevel: GDSHeadingLevel = '3',
): GDSHeadingLevel => {
  if (!parentHeadingLevel) {
    return fallbackLevel;
  }

  if (parentHeadingLevel === 'display') {
    return parentHeadingLevel;
  }

  const currentLevel = parseInt(parentHeadingLevel, 10);
  const nextLevel = Math.min(currentLevel + 1, 6);
  return nextLevel.toString() as GDSHeadingLevel;
};
